import styled from "styled-components";

const StyledApp = styled.div({
  padding: 0,
  margin: 0,
  ".container": {
    maxWidth: "1170px",
    margin: "auto",
    padding: "0 15px",
  },
});

export default StyledApp;
